import React, { useEffect, useState } from "react";
import MaterialTable from "material-table";
import { Strings } from "../../assets/res/en";
import useProgram from "../../hooks/modules/program/useProgram";
import useTableIcons from "../../hooks/useTableIcons";
import { Chip, LinearProgress } from "@material-ui/core";
import useStyles from "../../hooks/useStyles";
import Unauthorized from "../../components/Unauthorized";
import { SearchBar } from "../../components/searchBox/SearchBar";
import { ToolBar } from "../../components/tools";
import CardLevelTableDetails from "../../components/CardLevelTableDetails";
import ProgramQRModal from "../../components/Modals/ProgramQRModal";
export default function Programs(props) {
  const classes = useStyles();
  const { tableIcons } = useTableIcons();

  const onQRCodeSelected = (data) => {
    console.log('Se seleccionao un QR', data)
    onOpenQrModal(data)
    //getAllPrograms();
  }

  const {
    programs,
    isLoading,
    searchOptions,
    getAllPrograms,
    columns,
    sytlingOptions,
    userPermission,
    sprograms,
    filters,
    searchData,
    updateQRProgram
  } = useProgram({onQRCodeSelected});


  const [selected_data, setSelectedData] = useState()
  const [qrModal, setQrModal] = useState(false)

  useEffect(() => {
    if(selected_data){
      const _updateData = programs.find(el => el.idProgram === selected_data.idProgram)
      setSelectedData(_updateData)
    }
  }, [programs])

  const onOpenQrModal = (_data) => {
    setSelectedData(_data)
    setQrModal(true)
  }

  const onCloseQRModal = () => {
      setQrModal(false)
      setSelectedData(null)
  }

  const onQRUpdated = async() => {
    getAllPrograms();
  }

  useEffect(() => {
    getAllPrograms();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  //console.log(userPermission)

  const actions = {updateQRProgram}

  return (
    <>
      {userPermission.read === true ? (
        <>
          <ProgramQRModal
              open={qrModal}
              onClose={onCloseQRModal}
              origin={selected_data}
              actions={actions}
              onCompleted={onQRUpdated}
          />
          <SearchBar options={searchOptions} />
          <MaterialTable
            title={Strings.COLUMN_PROGRAM_TITLE}
            icons={tableIcons}
            columns={columns}
            data={programs}
            options={sytlingOptions}
            isLoading={isLoading}
            detailPanel={(rowData) => {
              return <CardLevelTableDetails data={rowData} key={`cardlvl-${rowData.idProgram}-${rowData.idGroup}-${rowData.idMerchant}`}/>
            }}
            components={{
              Toolbar: (props) => (
                <div>
                  <div
                    className={
                      filters.filter(
                        (item) =>
                          item.value && item.value.toString().trim() !== ""
                      ).length > 0
                        ? classes.filterContainer
                        : ""
                    }
                  >
                    {filters.filter(
                      (item) =>
                        item.value && item.value.toString().trim() !== ""
                    ).length > 0 &&
                      filters
                        .filter(
                          (item) =>
                            (item.value &&
                              item.value.toString().trim() !== "") ||
                            item.isClearAll === true
                        )
                        .map((fItem) =>
                          fItem.isClearAll === true ? (
                            <Chip
                              key={fItem.description}
                              color="secondary"
                              label="Reset All Filters"
                              onClick={() => fItem.clearAll(filters)}
                            />
                          ) : (
                            <Chip
                              key={fItem.description}
                              color="default"
                              label={fItem.value}
                              onDelete={() =>
                                fItem.remove(fItem, filters, searchData)
                              }
                            />
                          )
                        )}
                  </div>
                </div>
              ),
            }}
          ></MaterialTable>
        </>
      ) : userPermission.read === false ? (
        <Unauthorized />
      ) : (
        <LinearProgress />
      )}
    </>
  );
}
